// extracted by mini-css-extract-plugin
export default {"field":"LabelInputField_field__2PdPU","label":"LabelInputField_label__pOop5"};